import React from 'react'
import styled from 'styled-components'
import { DayPickerSingleDateController } from 'react-dates'
import 'moment/locale/nl'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import styles from './Datepicker.scss'
import PropTypes from 'prop-types'
import { darken } from 'polished'

const StyleDatePicker = styled.div`
  ${({ theme }) => `
    .CalendarDay__selected  {
      background: ${theme.primaryColor};
      border-color: ${theme.primaryColor};
    }

    .CalendarDay__selected:active,
    .CalendarDay__selected:hover {
      background: ${darken(0.1, theme.primaryColor)};
      border-color: ${darken(0.1, theme.primaryColor)};
    }
  `};
`

class DatePicker extends React.Component {
  static propTypes = {
    error: PropTypes.any,
    onDateChange: PropTypes.func,
    helpText: PropTypes.string,
    date: PropTypes.any,
  }

  constructor(props) {
    super(props)
    this.state = {
      focused: false,
    }

    this.onDateChange = this.onDateChange.bind(this)
  }

  onDateChange(date) {
    this.setState({ date })
    if (this.props.onDateChange) this.props.onDateChange(date)
  }

  render() {
    const { error, date, helpText, ...restProps } = this.props

    return (
      <StyleDatePicker>
        <DayPickerSingleDateController
          date={date}
          initialVisibleMonth={() => date}
          numberOfMonths={1}
          focused={true}
          hideKeyboardShortcutsPanel={true}
          onDateChange={this.onDateChange}
          {...restProps}
        />
        {helpText && <div className={styles.HelpText}>{helpText}</div>}
        {error}
      </StyleDatePicker>
    )
  }
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/components/DatePicker/DatePicker.js